/* Imports */
import React from "react"
import { Link } from "react-router-dom"
import { Font } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const PageLoadingPage = () => {
    const items = [
        {
            content: (
                <Font.P>
                    <Link to="/components/page-loading/demo" target="_blank" rel="noreferrer noopener">
                        Demo here
                    </Link>
                </Font.P>
            ),
            code: '<PageLoading color="secondary" />',
        },
    ]

    const propsItems = [
        {
            name: "color",
            type: "String",
            example: "danger",
            possible: commonProps.colorsShort,
            default: "primary",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default PageLoadingPage
